module.exports = __webpack_public_path__ + "img/addUsbanner.4078dc46.png";